module.exports = __webpack_public_path__ + "static/img/manual_zh_20.6d99d5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_20.png
// module id = NocE
// module chunks = 4